// @i18n-ignore-file
import { ExperimentDefinition } from '../experiments.types'

const EXPERIMENTS = {
  PDP_PARTNER_REC: {
    experimentName: 'pdp-partner-rec',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  PREORDER: {
    experimentName: 'preorder',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
} satisfies Record<string, ExperimentDefinition>

export default EXPERIMENTS
